/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedCourses200,
  GetApiV1ClassroomdisciplineSharedCourses401,
  GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCourses.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedCoursesQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCoursesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedCourses200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCourses200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedCourses401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCourses401>;

export const getApiV1ClassroomdisciplineSharedCoursesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedCourses200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCoursesQueryResponse>;
